import React from 'react';
import moment from "moment";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { browserHistory } from "react-router";
import Checkboxes from "../base/Checkboxes";
import { Page, PageHeader, PageBody } from "../base/Page";
import API from "../base/API";
import Auth from "../auth/Auth";
import { translate } from "../base/Translation";

import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

let DatePicker = require("react-bootstrap-date-picker");

/*eslint no-restricted-globals: 0 */

export default class WeaveEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_weave: "/weave/get/:weave",
			save_weave: "/weave/save/:weave",
			get_brands: "/brand/fetch/all",
			get_brands_by_client: "/brand/fetch/by/client/:client",
			get_forms: "/form/fetch/all",
			get_branches_by_brand: "/branch/fetch/by/brand/:brand",
            get_branches_competitive: "/branch/fetch/competitive",
			get_clients: "/client/fetch/all",
			mass_change: "/weave/mass/status/done/:weave",
			mass_change_closed: "/weave/mass/status/closed/:weave",
		});

		this.weave = false;

		this.state = {
			fix_months: [
				{ id: 0, name: translate("nezadané") },
				{ id: 1, name: translate("1 mesiac") },
				{ id: 2, name: translate("2 mesiace") },
				{ id: 3, name: translate("3 mesiace") },
				{ id: 4, name: translate("4 mesiace") },
				{ id: 5, name: translate("5 mesiacov") },
				{ id: 6, name: translate("6 mesiacov") }
			],
			available_forms: false,
			brands: false,
			branches: false,
			weave: false,
			clients: false
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	async fetchData() {
		this.api.request({
			route: "get_weave",
			params: { weave: this.props.params.weaveID },
			success: function (response) {
				this.weave = response;
				this.loadForms();
				this.loadClients();
				this.loadBrands();
				this.loadBranches();
			}.bind(this)
		});
	}

	loadForms() {
		this.api.request({
			route: "get_forms",
			success: (response) => {
				this.setState({ available_forms: response });
			}
		});
	}


	loadClients() {
		this.api.request({
			route: "get_clients",
			params: { "role": 3 },
			success: (response) => {
				this.setState({ clients: response });
			}
		});
	}

	loadBrands() {
		this.api.request({
			route: "get_brands_by_client",
			params: { client: this.weave.client },
			success: (response) => {
				this.setState({ brands: response });
			}
		});
	}

	loadBranches() {
		console.log(this.weave.competitive );
		this.api.request({
			route: (this.weave.competitive === "1" ? "get_branches_competitive" : "get_branches_by_brand"),
			params: { brand: this.weave.brand },
			success: (response) => {

				let branches = response.map((item) => {
					item.name = (item.city ? item.city + ", " : "") + (item.identifier ? item.identifier + ", " : "") + item.name + (item.address ? ", " + item.address : "");
					return item;
				});

				branches.sort(function (a, b) {
					if (a.name < b.name) return -1;
					if (a.name > b.name) return 1;
					return 0;
				})

				this.setState({ branches: branches });
			}
		});
	}

	reloadClients() {
		this.loadClients();
		this.reloadBrands();
	}

	reloadBranches() {
		this.weave["branches"] = [];
		this.setState({ branches: [] });

		this.loadBranches();
	}

	reloadBrands() {
		this.weave["brand"] = 0;
		this.setState({ brands: [] });

		this.loadBrands();
		this.reloadBranches();
	}

	/*
	 *
	 * Events
	 *
	 */

	onWeaveSave() {
		this.weave.date_from = this.weave.date_from.replace(new RegExp("/", 'g'), ".");
		this.weave.date_to = this.weave.date_to.replace(new RegExp("/", 'g'), ".");

		this.api.request({
			route: "save_weave",
			params: { weave: this.props.params.weaveID },
			data: this.weave,
			created: (response) => {
				browserHistory.push("/weaves");
			}
		});
	}

	onWeaveChange(evt) {
		this.weave[evt.target.name] = evt.target.value;
		if (evt.target.name === "brand" || evt.target.name === "competitive") {
            this.reloadBranches();
        }
		if (evt.target.name === "client") {
			this.reloadBrands();
		}
	}

	handleEditorChange(content) {
		this.component.onWeaveChange({
			target: {
				name: this.field,
				value: content
			}
		});
	}

	onWeaveDateFromChange(evt, date) {
		this.weave["date_from"] = date;
		//console.log(this.weave["date_from"]);
	}

	onWeaveDateToChange(evt, date) {
		this.weave["date_to"] = date;
	}

	onBranchesChange(actual_data) {
		this.weave.branches = actual_data;
	}

	callbackFormChange(forms) {
		this.weave.forms = forms;
	}

	massStatusChange() {
		if (!confirm(translate("Ste si istý?"))) {
			return;
		}

		this.api.request({
			route: "mass_change",
			params: { "weave": this.weave.id },
			success: (response) => {
				alert(response.message);
			}
		});
	}

	
	massStatusChangeClosed() {
		if (!confirm(translate("Ste si istý?"))) {
			return;
		}

		this.api.request({
			route: "mass_change_closed",
			params: { "weave": this.weave.id },
			success: (response) => {
				alert(response.message);
			}
		});
	}

	/*
	 *
	 * Render methods
	 *
	 */

	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		if (!this.weave || !this.state.available_forms || !this.state.brands || !this.state.branches || !this.state.clients) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		const date_from = moment(this.weave.date_from, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
		const date_to = moment(this.weave.date_to, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

		return (
			<Page>
				<PageHeader title={this.weave.name} right={() => {
					return (
						<div className="pull-right"> 
						{/*<button className="btn btn-sm btn-primary" onClick={this.massStatusChangeClosed.bind(this)} >{translate("Zmeniť všetky kontrolované na ukončené")}</button>*/}
						{/*<button className="btn btn-sm btn-primary" onClick={this.massStatusChange.bind(this)} >{translate("Zmeniť všetky ukončené na vykonané")}</button>*/}
						</div>
					)
				}} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné informácie")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl name="name" defaultValue={this.weave.name}
										onChange={this.onWeaveChange.bind(this)} />
								</FormGroup>
								<FormGroup style={{ display: "none" }}>
									<ControlLabel>{translate("Typ")}</ControlLabel>
									<FormControl componentClass="select" name="type" defaultValue={this.weave.type ? "1" : "0"}
										onChange={this.onWeaveChange.bind(this)}>
										<option value={"0"}>{translate("Test")}</option>
										<option value={"1"}>{translate("Anketa")}</option>
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Konkurenčná")}</ControlLabel>
									<FormControl componentClass="select" name="competitive" defaultValue={this.weave.competitive}
										onChange={this.onWeaveChange.bind(this)}>
										<option value={0}>{translate("Nie")}</option>
										<option value={1}>{translate("Áno")}</option>
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Minimálna úspešnosť (%)")}</ControlLabel>
									<FormControl name="req_perc" defaultValue={this.weave.req_perc}
										onChange={this.onWeaveChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Od")}</ControlLabel>
									<DatePicker dateFormat="DD.MM.YYYY" name="from" value={date_from}
										onChange={this.onWeaveDateFromChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Do")}</ControlLabel>
									<DatePicker dateFormat="DD.MM.YYYY" name="to" value={date_to}
										onChange={this.onWeaveDateToChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Maximálny počet opakovaní")}</ControlLabel>
									<FormControl name="max_repeats" defaultValue={this.weave.max_repeats}
										onChange={this.onWeaveChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Lehota pre nápravné opatrenia")}</ControlLabel>
									<FormControl componentClass="select" name="fix_months"
										defaultValue={this.weave.fix_months}
										onChange={this.onWeaveChange.bind(this)}>
										{this.renderOptions(this.state.fix_months)}
									</FormControl>
								</FormGroup>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Klient, značka a prevádzky")}>
								<FormGroup>
									<ControlLabel>{translate("Klient")}</ControlLabel>
									<FormControl componentClass="select" name="client" defaultValue={this.weave.client}
										onChange={this.onWeaveChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderOptions(this.state.clients)}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Značka")}</ControlLabel>
									<FormControl componentClass="select" name="brand" defaultValue={this.weave.brand}
										onChange={this.onWeaveChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderOptions(this.state.brands)}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Prevádzky")}</ControlLabel>
									<Checkboxes data={this.state.branches} actual_data={this.weave.branches}
										callback={this.onBranchesChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Komunikácia")}>
								<Row>
									<Col lg={6}>
										<FormGroup>
											<ControlLabel>{translate("Bodová váha")}</ControlLabel>
											<FormControl name="form_weight" defaultValue={this.weave.form_weight}
												onChange={this.onWeaveChange.bind(this)} />
										</FormGroup>
									</Col>
									<Col lg={6}>
										<FormGroup>
											<ControlLabel>{translate("Minimálna úspešnosť (%)")}</ControlLabel>
											<FormControl name="form_req_perc" defaultValue={this.weave.form_req_perc}
												onChange={this.onWeaveChange.bind(this)} />
										</FormGroup>
									</Col>
									<Col lg={12}>
										<FormGroup>
											<ControlLabel>{translate("Dotazník")}</ControlLabel>
											<FormControl
												componentClass="select"
												name="form"
												defaultValue={this.weave.form}
												onChange={this.onWeaveChange.bind(this)}
											>
												<option value={0}>{translate("Vyberte")}</option>
												{this.renderOptions(this.state.available_forms)}
											</FormControl>
										</FormGroup>
									</Col>
								</Row>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Pokyny vyplňovania dotazníka")}>
								<ReactQuill defaultValue={this.weave.questionaire_instructions}
									onChange={this.handleEditorChange.bind({ component: this, field: "questionaire_instructions" })} />
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Spracovanie príloh")}>
								<ReactQuill defaultValue={this.weave.processing_attachments}
									onChange={this.handleEditorChange.bind({ component: this, field: "processing_attachments" })} />
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Scenár návštevy")}>
								<ReactQuill defaultValue={this.weave.visit_scenario}
									onChange={this.handleEditorChange.bind({ component: this, field: "visit_scenario" })} />
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onWeaveSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		)
	}
}




// WEBPACK FOOTER //
// ./src/modules/weave/WeaveEdit.js